module.exports = __webpack_public_path__ + "static/media/5.46f7f66e.png";